<template>
  <div>
    <button class="config-menu__toggle-visibility" :class="{'config-menu__toggle-visibility--visible': visible}" v-on:click="toggleVisibility()"></button>
    <div class="config-menu" :class="{'config-menu--visible': visible}">
      <ul class="config-menu__main-options">
        <li>
          <button class="config-menu__action" v-on:click="$emit('show-events-changed', !showEvents); toggleVisibility()">
            {{ (showEvents) ? 'Hide' : 'Show' }} events
          </button>
        </li>
        <li>
          <button class="config-menu__action" v-on:click="$emit('show-event-names-changed', !showEventNames); toggleVisibility()">
            {{ (showEventNames) ? 'Hide' : 'Show' }} event names
          </button>
        </li>              
      </ul>   

      <ul class="config-menu__secondary-options">
        <li>
          <button class="config-menu__action" v-on:click="$emit('change-calendar-clicked'); toggleVisibility()">Change room</button>
        </li>
        <li>
          <button class="config-menu__action config-menu__action--red" v-on:click="$emit('sign-out-clicked'); toggleVisibility()">Sign out</button>
        </li> 
      </ul>            
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfigMenu',
  props: {
    showEvents: Boolean,
    showEventNames: Boolean
  },
  data: function() {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisibility: function() {
      this.visible = !this.visible;
      this.$emit('menu-visibility-changed', this.visible);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/components/colours';

.config-menu__toggle-visibility {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20000;

  font-size: 1vh;
  background: none;
  border: none;
  width: 10em;
  height: 10em;
  box-sizing: border-box;
  color: rgba(255,255,255,0.2);

  &:before {
    content: '';
    border-top: 1em solid currentColor;
    border-bottom: 1em solid currentColor;
    display: block;
    position: absolute;
    top: 2em;
    left: 2em;
    bottom: 2em;
    right: 2em;
    transition: transform 0.2s, border 0.2s, top 0.2s, bottom 0.2s;
  }

  &:after {
    content: '';
    position: absolute;
    top: calc(50% - 0.5em);
    left: 2em;
    right: 2em;
    border-top: 1em solid currentColor;
    display: block;
    transition: transform 0.2s;
  }  

  &--visible {
    color: $white;

    &:before {
      border-top-width: 0.5em;
      border-bottom-width: 0.5em;
      top: calc(50% - 0.5em);
      bottom: auto;
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}


.config-menu {
  position: absolute;
  font-size: 5vh;
  top: 0;
  bottom: 0;
  left: 0;
  transform: translateX(-33vw);
  width: 33vw;
  z-index: 10000;
  transition: transform 0.1s;
  background: linear-gradient(to right, lighten($black, 10%) 90%, lighten($black, 8%) 100%);
  padding-top: 2em;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &--visible {
    transform: translateX(0);
  }

  &__main-options {
    li {
      border-bottom: 1px solid $border-grey;
    }
  }

  &__secondary-options {
    li {
      border-top: 1px solid $border-grey;
    }
  }  

  &__action {
    font-size: 1em;
    background: none;
    border: none;
    padding: 0.5em;
    display: block;
    width: 100%;
    color: $white;
    text-decoration: none;
    text-align: left;

    &--red {
      color: lighten($red, 20%);
    }
  }

}
</style>